import React from 'react';
import { Link } from 'react-router-dom';
import './../css/error.css';

const NotFound = () => (
    // window.location.href='http://cs.kmsgtech.com/cs'
    <div className="error">
        <div className="contentWrapper">
            <h1>We have changed the url</h1>
            <Link className="homepage" to="/cs">
                Go to Home Page
            </Link>
        </div>

    </div>
);

export default NotFound;